import { logEvent } from "firebase/analytics";

export const logAnalyticsEvent = (analyticsInstance, event) => {
  if (!analyticsInstance) {
    console.error("Analytics instance is not initialized");
    return;
  }

  logEvent(analyticsInstance, event.name, event.params);
};

export const ANALYTICS_EVENTS = {
  LOGIN_CLICK_BUTTON: {
    name: "login_click_button",
    params: {
      element_name: "login_button",
      location: "LoginPage",
    },
  },
  LOGIN_IAM_CLICK_BUTTON: {
    name: "login_iam_click_button",
    params: {
      element_name: "login_iam_button",
      location: "LoginPage",
    },
  },
  LOGIN_RESET_CLICK_BUTTON: {
    name: "login_reset_click_button",
    params: {
      element_name: "login_reset_button",
      location: "LoginPage",
    },
  },

}

export const ANALYTICS_EVENTS_SEARCH = {
  DO_SEARCH: {
    name: "search_ugems",
    params: {
      element_name: "btn-search-insting-cari",
      location: "reportvalidation",
    },
  },
  ACTION_VALID: {
    name: "search_action_valid",
    params: {
      element_name: "btn-hazard-valid",
      location: "reportsearch",
    },
  },
  ACTION_NOT_VALID: {
    name: "search_action_notvalid",
    params: {
      element_name: "btn-hazard-notvalid",
      location: "reportsearch",
    },
  },
  ACTION_DELETE: {
    name: "search_action_delete",
    params: {
      element_name: "btn-hazard-delete",
      location: "reportsearch",
    },
  },
  ACTION_CONFIRM: {
    name: "search_action_confirm",
    params: {
      element_name: "btn-hazard-confirm",
      location: "reportsearch",
    },
  },
}


export const ANALYTICS_EVENTS_CONFIRMATION = {
  ACTION_VALID: {
    name: "search_action_valid",
    params: {
      element_name: "btn-hazard-valid",
      location: "reportconfirmation",
    },
  },
  ACTION_NOT_VALID: {
    name: "search_action_notvalid",
    params: {
      element_name: "btn-hazard-notvalid",
      location: "reportconfirmation",
    },
  },
  ACTION_DELETE: {
    name: "search_action_delete",
    params: {
      element_name: "btn-hazard-delete",
      location: "reportconfirmation",
    },
  },
  ACTION_CONFIRM: {
    name: "search_action_confirm",
    params: {
      element_name: "btn-hazard-confirm",
      location: "reportconfirmation",
    },
  },
}